<template>
  <div class="homefooterad_main">
    <div
      v-if="slogentext"
      class="homefooterad_top"
      :style="{ 'background-color': showChangAn ? changanCss : navColorSlogen }"
    >
      <span>
        <!-- 此处为高能所改变了slogentext -->
        <span v-if="!showChangAn">
          {{
          isGaonS
          ? isEnglish && (slogentext || "").indexOf("*##*") != -1
          ? (slogentext || "").split("*##*")[1]
          : (slogentext || "").split("*##*")[0]
          : slogentext
          }}
        </span>
        <!-- <span>视觉无处不在&nbsp;&nbsp;</span>
        <span>·</span>
        <span>&nbsp;&nbsp;视觉服务中国</span>-->
      </span>
    </div>
    <div class="homefooterad_bottom" :style="{ 'background-color': navColorBot }">
      <div class="homefooterad_bottom_main">
        <div class="homefooterad_bottom_logo">
          <img :src="m4blogo.photo2" />
          <!-- <img src="../../static/images/icon/blogo.png" /> -->
        </div>
        <div class="footer_group" v-for="(group, index) in groups" :key="index">
          <footer-group :obj="group"></footer-group>
        </div>
        <div class="footer_group2" v-if="nfshowcode">
          <div class="sns">
            <div class="snstop">社交媒体</div>
            <div class="snsbot">
              <div class="snsbot1">
                <div v-if="lefttop" class="snsitem" @mouseover="lefttopOver" @mouseout="lefttopOut">
                  <div class="snsitemdesc">官方微信</div>
                  <img src="../../static/images/icon/nf.jpg" />
                </div>
                <div v-else class="snsitemhover" @mouseover="lefttopOver" @mouseout="lefttopOut">
                  <div style="text-align:center;margin-bottom:10px">官方微信</div>
                  <img src="../../static/images/icon/nf.jpg" />
                </div>
                <!-- <div v-if="righttop" class="snsitem" @mouseover="righttopOver" @mouseout="righttopOut">
                  <div class="snsitemdesc">中山画刊微信</div>
                  <img src="../../static/images/icon/righttop.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="righttopOver" @mouseout="righttopOut">
                  <div style="text-align:center;margin-bottom:10px">中山画刊微信</div>
                  <img src="../../static/images/icon/righttop.jpg">
                </div>-->
              </div>
              <!-- <div class="snsbot2">
                <div v-if="leftbot" class="snsitem" @mouseover="leftbotOver" @mouseout="leftbotOut">
                  <div class="snsitemdesc">中山日报APP</div>
                  <img src="../../static/images/icon/leftbot.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="leftbotOver" @mouseout="leftbotOut">
                  <div style="text-align:center;margin-bottom:10px">中山日报APP</div>
                  <img src="../../static/images/icon/leftbot.jpg">
                </div>
                <div v-if="rightbot" class="snsitem" @mouseover="rightbotOver" @mouseout="rightbotOut">
                  <div class="snsitemdesc">中山网</div>
                  <img src="../../static/images/icon/rightbot.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="rightbotOver" @mouseout="rightbotOut">
                  <div style="text-align:center;margin-bottom:10px">中山网</div>
                  <img src="../../static/images/icon/rightbot.jpg">
                </div>
              </div>-->
            </div>
          </div>
        </div>
        <div class="footer_group2" v-if="snshowcode">
          <div class="sns">
            <div class="snstop" :style="{ 'color': webID == '111144' ? sanNongCss :'' }">社交媒体</div>
            <div class="snsbot">
              <div class="snsbot1" :style="{ 'color': webID == '111144' ? sanNongCss :'' }">
                <div
                  v-if="lefttop"
                  class="snsitem"
                  @mouseover="lefttopOver"
                  @mouseout="lefttopOut"
                  :style="{ 'color': webID == '111144' ? sanNongCss :'','border':webID == '111144' ? '1px solid #000' :'' }"
                >
                  <div class="snsitemdesc">三农号APP</div>
                  <img src="../../static/images/icon/snAPP.png" />
                </div>
                <div v-else class="snsitemhover" @mouseover="lefttopOver" @mouseout="lefttopOut">
                  <div style="text-align:center;margin-bottom:10px">三农号APP</div>
                  <img src="../../static/images/icon/snAPP.png" />
                </div>
                <div
                  v-if="righttop"
                  class="snsitem"
                  @mouseover="righttopOver"
                  @mouseout="righttopOut"
                  :style="{ 'color': webID == '111144' ? sanNongCss :'','border': webID == '111144' ? '1px solid #000' :'' }"
                >
                  <div class="snsitemdesc">农民日报微博</div>
                  <img src="../../static/images/icon/snwb.png" />
                </div>
                <div v-else class="snsitemhover" @mouseover="righttopOver" @mouseout="righttopOut">
                  <div style="text-align:center;margin-bottom:10px">农民日报微博</div>
                  <img src="../../static/images/icon/snwb.png" />
                </div>
              </div>
              <div class="snsbot2" :style="{ 'color': webID == '111144' ? sanNongCss :'' }">
                <div
                  v-if="leftbot"
                  class="snsitem"
                  @mouseover="leftbotOver"
                  @mouseout="leftbotOut"
                  :style="{ 'color': webID == '111144' ? sanNongCss :'','border': webID == '111144' ? '1px solid #000' :'' }"
                >
                  <div class="snsitemdesc">农民日报微信</div>
                  <img src="../../static/images/icon/snWX.jpg" />
                </div>
                <div v-else class="snsitemhover" @mouseover="leftbotOver" @mouseout="leftbotOut">
                  <div style="text-align:center;margin-bottom:10px">农民日报微信</div>
                  <img src="../../static/images/icon/snWX.jpg" />
                </div>
                <div
                  v-if="rightbot"
                  class="snsitem"
                  @mouseover="rightbotOver"
                  @mouseout="rightbotOut"
                  :style="{ 'color': webID == '111144' ? sanNongCss :'','border': webID == '111144' ? '1px solid #000' :'' }"
                >
                  <div class="snsitemdesc">中国农网</div>
                  <img src="../../static/images/icon/snZW.png" />
                </div>
                <div v-else class="snsitemhover" @mouseover="rightbotOver" @mouseout="rightbotOut">
                  <div style="text-align:center;margin-bottom:10px">中国农网</div>
                  <img src="../../static/images/icon/snZW.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="homefooterad_bottom_copyrite" v-if="!ifChangan">
        <!-- <div> -->
        <!-- <span style="cursor:pointer">网站条款</span>
          <span class="line">&nbsp;|&nbsp;</span>
          <span style="cursor:pointer">版权声明</span>
        <span class="line">&nbsp;|&nbsp;</span>-->
        <!-- 津ICP备13002056号-2 天津市武清公安分局 -->
        <div>
          <span>
            <a :href="linkInfo" target="_blank" style="color: #adadad;">
              {{
              isGaonS
              ? isEnglish && (recordinfo || "").indexOf("*##*") != -1
              ? (recordinfo || "").split("*##*")[1]
              : (recordinfo || "").split("*##*")[0]
              : recordinfo
              }}
            </a>
            <span>&nbsp;&nbsp;&nbsp;</span>
            {{
            isGaonS
            ? isEnglish
            ? "Note: the copyright of this website belongs to: "
            : "注：此网站版权属于: "
            : "注：此网站版权属于: "
            }}
            {{
            isGaonS
            ? isEnglish && (companyinfo || "").indexOf("*##*") != -1
            ? (companyinfo || "").split("*##*")[1]
            : (companyinfo || "").split("*##*")[0]
            : companyinfo
            }}
            <span>&nbsp;&nbsp;&nbsp;</span>
          </span>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import footerGroup from "./footerGroup";
import { getModuleInfo, getFooterInfo, getwebid } from "./../services/api.js";
import { mapGetters, mapActions } from "vuex";
import pbmethod from "../publicmethod.js";
export default {
  data() {
    return {
      recordinfo: "",
      companyinfo: "",
      linkInfo: "",
      slogentext: "",
      navColorBot: "#282828",
      navColorSlogen: "#181A1A",
      changanCss: "#3366CC",
      nfshowcode: false,
      snshowcode: false,
      sanNongCss: "#000000",
      groups: [
        {
          title: "集团介绍",
          list: [
            { title: "关于我们", url: "" },
            { title: "产品介绍", url: "" },
            { title: "合作伙伴", url: "" }
          ]
        },
        {
          title: "帮助中心",
          list: [
            { title: "网站指南", url: "" },
            { title: "购图指南", url: "" },
            { title: "供图指南", url: "" }
          ]
        },
        {
          title: "联系我们",
          list: [
            { title: "010-1234567", url: "" },
            { title: "www.baidu.com", url: "" }
          ]
        }
      ],
      m4blogo: {},
      moduleIds: [14],
      lefttop: true,
      righttop: true,
      leftbot: true,
      rightbot: true,
      ifChangan: false
    };
  },
  components: {
    footerGroup
  },
  mounted() {
    this.getDomainName();
    getwebid({ domainName: window.location.host }).then(res => {
      if (res) {
        this.getMInfo();
        this.getFooter();
      }
    });

    this.ifChangan = JSON.parse(sessionStorage.getItem("ifChangan"));
  },
  computed: {
    ...mapGetters(["example", "webID", "isGaonS", "isEnglish", "showChangAn"])
  },
  created() {},
  methods: {
    ...mapActions([
      //是否是高能所
      "setisGaonS",
      //是否是英文
      "setisEnglish"
    ]),
    getDomainName() {
      if (window.location.host.indexOf("nf.vcg") > -1) {
        this.nfshowcode = true;
      }
      if (window.location.host.indexOf("farmer.vcg") > -1) {
        this.snshowcode = true;
      }
    },
    getFooter() {
      getFooterInfo({ web_id: this.webID }).then(res => {
        if (res.status_code == 1) {
          this.groups = res.data;
        }
      });
    },
    webtermsClick() {
      let routeData = this.$router.resolve({
        path: "/webterms"
      });
      window.open(routeData.href, "_blank");
    },
    copyrightClick() {
      let routeData = this.$router.resolve({
        path: "/copyright"
      });
      window.open(routeData.href, "_blank");
    },
    lefttopOver() {
      this.lefttop = !this.lefttop;
    },
    lefttopOut() {
      this.lefttop = !this.lefttop;
    },
    righttopOver() {
      this.righttop = !this.righttop;
    },
    righttopOut() {
      this.righttop = !this.righttop;
    },
    leftbotOver() {
      this.leftbot = !this.leftbot;
    },
    leftbotOut() {
      this.leftbot = !this.leftbot;
    },
    rightbotOver() {
      this.rightbot = !this.rightbot;
    },
    rightbotOut() {
      this.rightbot = !this.rightbot;
    },
    getMInfo() {
      this.moduleIds.forEach(item => {
        let data = {
          module_id: 4,
          web_id: this.webID,
          use_sort_num: 1,
          sort: "asc"
        };
        getModuleInfo(data).then(res => {
          if (res.status_code == 1) {
            if (res.data.list.length > 0) {
              this.m4blogo = res.data.list[0];
            }
          }
        });
      });
      getModuleInfo({ module_id: 5, use_sort_num: 1, sort: "asc" }, null).then(
        res => {
          if (res.status_code == 1) {
            this.navColorBot = pbmethod.colorRgb(res.data.list[0].body1);
            this.navColorSlogen = pbmethod.colorRgb(res.data.list[0].body2);
            this.slogentext = res.data.list[0].body3;
          }
        }
      );
      getModuleInfo({
        module_id: 23,
        web_id: this.webID,
        use_sort_num: 1,
        sort: "asc"
      }).then(res => {
        if (res.status_code == 1) {
          this.recordinfo = res.data.list[0].body1;
          this.companyinfo = res.data.list[0].body2;
          this.linkInfo = res.data.list[0].body3;
        }
      });
    }
  }
};
</script>

<style lang="less">
.homefooterad_main {
  // position: relative;
  height: 100%;
  .homefooterad_top {
    height: 35px;
    text-align: center;
    line-height: 35px;
    color: white;
    // background-color: #181a1a;

    //
    // margin: 0px -20px;
    // 282828
  }
  .homefooterad_bottom {
    // background-color: #282828;
    position: absolute;
    // top: 35px;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    .homefooterad_bottom_main {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      .footer_group {
        width: 100px;
        margin-right: 100px;
      }
      .footer_group2 {
        .sns {
          color: #adadad;
          .snstop {
            margin-bottom: 15px;
            font-weight: bold;
            font-size: 13px;
          }
          .snsbot {
            position: relative;
            .snsbot1 {
              z-index: 99;
              display: flex;
              display: -webkit-flex;
              .snsitem {
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                padding: 5px 5px;
                height: 30px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  height: 100%;
                }
              }
              .snsitemhover {
                text-align: center;
                z-index: 99;
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                background-color: black;
                padding: 1px 1px;
                height: 140px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  width: 85%;
                }
              }
            }
            .snsbot2 {
              position: absolute;
              top: 50px;
              // z-index: 99;
              display: flex;
              display: -webkit-flex;
              .snsitem {
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                padding: 5px 5px;
                height: 30px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  height: 100%;
                }
              }
              .snsitemhover {
                text-align: center;
                z-index: 99;
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                background-color: black;
                padding: 1px 1px;
                height: 140px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  width: 85%;
                }
              }
            }
          }
        }
      }
      .homefooterad_bottom_logo {
        width: 120px;
        margin-right: 100px;
        img {
          max-width: 120px;
          // width: 50%;
          // height: 100%;
        }
      }
      position: absolute;
      bottom: 50px;
      left: 100px;
      top: 50px;
      right: 100px;
    }
    .homefooterad_bottom_copyrite {
      border-top: 1px solid #5d5d5d;
      // height: 30px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      right: 0px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      // margin: 0px -20px;
      // padding-top: 20px;
      color: #adadad;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeFooter.vue